/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceEtcResponse
 */
export interface DeviceEtcResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceEtcResponse
     */
    deviceTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceEtcResponse
     */
    groupName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DeviceEtcResponse
     */
    lastUpgradeRuleModifiedAt: Date | null;
}

export function DeviceEtcResponseFromJSON(json: any): DeviceEtcResponse {
    return DeviceEtcResponseFromJSONTyped(json, false);
}

export function DeviceEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceTypeName': json['deviceTypeName'],
        'groupName': json['groupName'],
        'lastUpgradeRuleModifiedAt': (json['lastUpgradeRuleModifiedAt'] === null ? null : new Date(json['lastUpgradeRuleModifiedAt'])),
    };
}

export function DeviceEtcResponseToJSON(value?: DeviceEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceTypeName': value.deviceTypeName,
        'groupName': value.groupName,
        'lastUpgradeRuleModifiedAt': (value.lastUpgradeRuleModifiedAt === null ? null : value.lastUpgradeRuleModifiedAt.toISOString()),
    };
}

